import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App min-h-screen bg-background">
      <Navbar />
      <main className="pt-0">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
